import { useCallback } from 'react'
import { useSearchBox } from 'react-instantsearch'

import Autocomplete from '@src/components/Autocomplete'

const AutocompleteOnSearchPage = () => {
  const { query, refine } = useSearchBox()

  const handleQueryChange = useCallback(
    (query: string) => {
      refine(query)
    },
    [refine],
  )

  return (
    <Autocomplete
      handleQueryChange={handleQueryChange}
      initialState={{ query }}
    />
  )
}

export default AutocompleteOnSearchPage
